import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as api from '../../api/notificationApi';

export const fetchNotifications = createAsyncThunk('notif/fetchAll', async (_, {rejectWithValue}) => {
  try { return (await api.getNotifications()).data.data; } catch(e) { return rejectWithValue(e.response?.data?.message); }
});
export const fetchUnreadCount = createAsyncThunk('notif/unreadCount', async (_, {rejectWithValue}) => {
  try { return (await api.getUnreadCount()).data.data; } catch(e) { return rejectWithValue(e.response?.data?.message); }
});
export const markRead    = createAsyncThunk('notif/markRead',    async (id, {rejectWithValue}) => {
  try { await api.markRead(id); return id; } catch(e) { return rejectWithValue(e.response?.data?.message); }
});
export const markAllRead = createAsyncThunk('notif/markAllRead', async (_, {rejectWithValue}) => {
  try { await api.markAllRead(); return true; } catch(e) { return rejectWithValue(e.response?.data?.message); }
});

const s = createSlice({ name: 'notifications', initialState: { list: [], unreadCount: 0, loading: false },
  reducers: {},
  extraReducers: b => {
    b.addCase(fetchNotifications.pending, s => { s.loading = true; })
     .addCase(fetchNotifications.fulfilled, (s,{payload}) => { s.loading = false; s.list = payload || []; s.unreadCount = (payload||[]).filter(n=>!n.isRead).length; })
     .addCase(fetchUnreadCount.fulfilled, (s,{payload}) => { s.unreadCount = payload || 0; })
     .addCase(markRead.fulfilled, (s,{payload}) => { const n = s.list.find(n=>n.id===payload); if(n) { n.isRead=true; s.unreadCount = Math.max(0, s.unreadCount-1); } })
     .addCase(markAllRead.fulfilled, s => { s.list.forEach(n=>n.isRead=true); s.unreadCount = 0; });
  }
});
export default s.reducer;
